var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocked = function SvgLocked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#locked_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#locked_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M20.5 14.413v-4.366c0-2.274-2.02-4.127-4.5-4.127s-4.5 1.853-4.5 4.127v4.366zm-10.666 0v-4.366c0-3.194 2.766-5.794 6.166-5.794s6.167 2.6 6.167 5.794v4.366h.5a2.667 2.667 0 0 1 2.666 2.667v8a2.667 2.667 0 0 1-2.666 2.667H9.333a2.667 2.667 0 0 1-2.666-2.667v-8a2.667 2.667 0 0 1 2.666-2.667z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    d: "M16.667 24.08v-2.12A1.997 1.997 0 0 0 16 18.08c-1.107 0-2 .893-2 2 0 .867.56 1.6 1.333 1.88v2.12z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "locked_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#fff",
    rx: 4
  })), /*#__PURE__*/React.createElement("filter", {
    id: "locked_svg__b",
    width: 24.666,
    height: 29.493,
    x: 3.667,
    y: 1.253,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8448_130348"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_8448_130348",
    result: "shape"
  })))));
};
export default SvgLocked;